<script lang="ts">
    import type { ITrxStripe } from '../../order'
    import Icon from '@iconify/svelte'
    import type { DateTime } from 'luxon'

    import { WDATA } from 'hydria/context'
    import { asAny } from 'hydria/svelte_helpers'
    import { toLuxon } from 'hydria/utils/time'

    import Date from 'hydria/components/Date.svelte'
    import IntCurrency from 'wdom/components/IntCurrency.svelte'

    interface Props {
        trx: ITrxStripe
    }

    let { trx }: Props = $props()

    let expandTransaction = false
    let expandFinal = false

    let expiresAt: DateTime | undefined = $derived(trx.status == 'open' && trx.data.session && trx.data.session.expires_at ? toLuxon(trx.data.session.expires_at) : undefined)

    function piUrl(payment_intent: string) {
        return WDATA['stripe_pi_url'].replace('{PAYMENT_INTENT}', payment_intent)
    }

    let copyTimer: ReturnType<typeof setTimeout> | undefined = $state(undefined)
    let copied: boolean | null = $state(null)

    // rxun(() => {
    //     if (copied !== null) {
    //         if (copyTimer) clearTimeout(copyTimer)
    //         copyTimer = setTimeout(() => {
    //             copied = null
    //             copyTimer = undefined
    //         }, 3000)
    //     } else if (copyTimer) {
    //         clearTimeout(copyTimer)
    //         copyTimer = undefined
    //     }
    // })

    function copyToClipboard(text: string) {
        copied = null
        navigator.clipboard.writeText(text).then(
            () => {
                // notify({
                //     type: 'success',
                //     title: $_('View zone as text'),
                //     text: $_('The text has been copied to the clipboard.'),
                // })
                copied = true

                if (copyTimer) clearTimeout(copyTimer)
                copyTimer = setTimeout(() => {
                    copied = null
                    copyTimer = undefined
                }, 3000)
            },
            () => {
                // notify({
                //     type: 'danger',
                //     title: $_('View zone as text'),
                //     text: $_('Could not copy the text.'),
                // })
                copied = false
            },
        )
    }
</script>

<h4>Stripe</h4>

<table class="table">
    <tbody>
        <tr><th>Status</th><td>{trx.status}</td></tr>
        {#if expiresAt}
            <tr><th>Expiration</th><td><Date value={expiresAt} format="h-table" /></td></tr>
        {/if}
        <tr><th>Modif. de session</th><td><Date value={trx.session_stamp} format="h-table" /></td></tr>
        <tr><th>Type de carte</th><td>{trx.data.charge?.payment_method_details?.card?.brand}</td></tr>
        <tr><th>Fin # carte</th><td>{trx.data.charge?.payment_method_details?.card?.last4}</td></tr>
        <tr><th>Exp</th><td>{trx.data.charge?.payment_method_details?.card?.exp_month} / {trx.data.charge?.payment_method_details?.card?.exp_year}</td></tr>
        <tr><th>Auth code</th><td>{trx.data.charge?.payment_method_details?.card?.authorization_code}</td></tr>
        <tr><th>Checkout</th><td>{trx.data.session_id}</td></tr>
        <tr
            ><th>Payment Intent</th><td>
                {#if trx.data.payment_intent_id != null}
                    <a href={piUrl(trx.data.payment_intent_id)} target="_blank">{trx.data.payment_intent_id} <Icon inline icon="mdi:open-in-new" /></a>
                    <button class="btn btn-sm" type="button" onclick={() => copyToClipboard(asAny(trx.data.payment_intent_id))} disabled={copied !== null} class:btn-success={copied} class:btn-danger={copied != null && !copied} class:btn-outline-secondary={copied == null}>
                        <Icon inline icon="mdi:clipboard-outline" />
                        {#if copied !== null}
                            <Icon inline icon={copied ? 'mdi:clipboard-check' : 'mdi:clipboard-alert'} />
                        {/if}
                    </button>
                {/if}
            </td></tr
        >
        <tr><th>Customer ID</th><td>{trx.data.session && trx.data.session.customer ? trx.data.session.customer : '–'}</td></tr>
        {#if trx.data.payment_intent && trx.data.payment_intent.charges && trx.data.payment_intent.charges.data}
            {#each trx.data.payment_intent.charges.data as charge, ci}
                <tr>
                    <th>Charge {ci + 1}</th>
                    <td>
                        Amount: <IntCurrency value={charge.amount} /><br />
                        Received: <IntCurrency value={charge.amount_received} /><br />
                        Refunded: <IntCurrency value={charge.amount_refunded} /><br />
                        Captured: {charge.captured ? 'Oui' : 'Non'}<br />
                        Disputed: {charge.disputed ? 'Oui' : 'Non'}<br />
                        Refunded: {charge.refunded ? 'Oui' : 'Non'}<br />
                        <a href={charge.receipt_url} target="_blank">Reçu (Stripe)</a>
                    </td>
                </tr>
            {/each}
        {/if}
    </tbody>
</table>
